import { cdnUploadsBaseUrl } from "~/common/Constants/links";

export const bgImageWithoutTextMobile = `${cdnUploadsBaseUrl}/design/2025/3/plus-ad/img-sm.png`;

export const bgImageWithoutTextDesktop = `${cdnUploadsBaseUrl}/design/2025/3/plus-ad/img-lg.png`;

export const bgImageWithTextMobile = `${cdnUploadsBaseUrl}/design/2025/3/plus-ad/free-mobile.png`;

export const bgImageWithTextTablet = `${cdnUploadsBaseUrl}/design/2025/3/plus-ad/free-tablet.png`;

export const bgImageWithTextDesktop = `${cdnUploadsBaseUrl}/design/2025/3/plus-ad/free-desktop.png`;
